<template>
  <nav class="glass-mobile-nav" aria-label="Mobile navigation">
    <RouterLink
      v-for="link in navLinks"
      :key="link.to"
      :to="link.to"
      class="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
      active-class="text-brand-orange font-semibold"
      @click="$emit('close')"
    >
      {{ link.label }}
    </RouterLink>
    <BaseButton :href="homeCtas.bookConsultation.href" variant="primary" block class="mt-2" @click="$emit('close')">
      {{ homeCtas.bookConsultation.label }}
    </BaseButton>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { navLinks, homeCtas } from '@/config/site'
import BaseButton from '@/components/ui/BaseButton.vue'

defineEmits(['close'])
</script>
